export default [
  {
    icon: 'mdi-download',
    title: 'Unduh Sertifikat',
    event: 'onDownloadSertifikat',
    akses: true,
  },
];
